<template>
    <div>
        <v-form>
            <v-row>
                <v-col>
                    <h2>Login</h2>
                </v-col>
            </v-row>
            <v-alert
                outlined
                :type="alertType"
                prominent
                v-if="msg"
                border="left"
            >
                {{ msg }}
            </v-alert>
            <v-row>
                <v-col>
                    <v-text-field v-model="username" label="Username"/>
                    <v-text-field v-model="password" label="Passwort" type="password"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn
                        large
                        class="cyan"
                        dark
                        @click="login"
                        :loading="isLoading"
                    >
                        Einloggen
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <router-link to="/sign-up"><small>Noch nicht registriert?</small></router-link>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>
<script>
import AuthService from '@/services/AuthService.js';

export default {
    data() {
        return {
            username: '',
            password: '',
            msg: '',
            isLoading: false,
            alertType: 'warning'
        };
    },
    methods: {
        async login() {
            this.isLoading = true
            try {
                const credentials = {
                    username: this.username,
                    password: this.password
                };
                const response = await AuthService.login(credentials);
                this.alertType = 'success'
                this.msg = response.msg;
                const token = response.token;
                const user = response.user;
                console.log(response)
                this.$store.dispatch('login', {token, user});
                this.$emit('success')
            } catch (error) {
                this.alertType = 'warning'
                if (error.response) this.msg = error.response.data.msg;
            }
            this.isLoading = false
        }
    }
};
</script>
